import React from 'react'
import { Link } from 'react-router-dom';
import PageBanner from '../../../../common/components/PageBanner';
import BriefHistory from '../../../../assets/our-history-image.png';
import "../styles/Ourhistory.css"

// TODO(refresh): set these to the supplied Our Story header banner and body
// image (the body image replaces the "Emergency Response Plan" graphic).
import STORY_BANNER from '../../../../assets/new-images/Our_story.png';
import STORY_BODY_IMAGE from '../../../../assets/new-images/brief-history_community.png';

// TODO(refresh): the military red-folder origin story stays off the page until
// MYREDFOLDER, Inc. confirms the wording. It must not say NEPTA created or owns
// the product.

const planContents = [
  { title: "Household members and pets", body: "Who lives in your home, including pet details." },
  { title: "Contacts and meeting places", body: "Emergency contacts and where your family will meet." },
  { title: "Relevant hazards", body: "The hazards that matter where you live." },
  { title: "Important records", body: "Documents your household may need, kept together." },
  { title: "Home inventory", body: "Property details that help you organize recovery." },
  { title: "Reviewed together", body: "A plan your household knows and updates as life changes." },
];

const OurHistoryComponent = () => {
  return (
    <div>
      <PageBanner
        image={STORY_BANNER}
        alt="A family and a MYREDFOLDER specialist reviewing documents laid out along a table."
        eyebrow="About Us / Our Story"
        title="Our Story"
      />

      <section className="mrf-section">
        <div className="mrf-container mrf-split">
          <div>
            <img
              src={STORY_BODY_IMAGE || BriefHistory}
              alt={STORY_BODY_IMAGE
                ? "A family and a MYREDFOLDER specialist reviewing documents laid out along a table."
                : "Hands holding puzzle pieces that read Emergency Response Plan."}
              style={{ width: "100%", height: "auto", borderRadius: 10, display: "block" }}
            />
          </div>
          <div>
            <h2 className="mrf-heading">How MYREDFOLDER® began</h2>
            <p className="mrf-body">
              MYREDFOLDER® began with a simple question: If something unexpected happened today, would the people you
              love know where to go, how to reach one another, and where to find the information they need?
            </p>
            <p className="mrf-body">
              Inspired by the idea of keeping a family's most important instructions together, MYREDFOLDER® was
              developed as a digital family preparedness platform. MYREDFOLDER, Inc. offers the program, and NEPTA
              administers it with emergency management experience in training and outreach.
            </p>
            <p className="mrf-body">
              Families can build a household plan, record meeting places and contacts, organize important documents and
              property details, and update the plan as circumstances change.
            </p>
          </div>
        </div>
      </section>

      <section className="mrf-section mrf-section--alt" aria-labelledby="plan-contents-heading">
        <div className="mrf-container">
          <h2 id="plan-contents-heading" className="mrf-heading mrf-heading--center">What goes into a MYREDFOLDER® plan</h2>
          <ul className="mrf-grid-3" style={{ listStyle: "none", padding: 0, margin: "28px 0 0" }}>
            {planContents.map((item) => (
              <li key={item.title} className="mrf-card">
                <h3 className="mrf-card__title">{item.title}</h3>
                <p className="mrf-card__body">{item.body}</p>
              </li>
            ))}
          </ul>
          <p style={{ textAlign: "center", marginTop: 32 }}>
            <Link className="mrf-btn mrf-btn--primary" to="/ourServices/my-mrf-plan">Explore the MYREDFOLDER® Plan</Link>
          </p>
        </div>
      </section>
    </div>
  )
}

export default OurHistoryComponent;
